/**
 * config.js
 * Configuration des structures et collaborateurs
 * À mettre à jour quand un nouveau collaborateur est ajouté
 */

const STRUCTURES = {
  LILLYBELLE_H: {
    id: 'LILLYBELLE_H',
    name: 'Lillybelle Group',
    country: 'France',
    collaborators: [
      'BOISSEL_PASCALE',
      'MAUDUIT_ARNAUD',
      'MORNET_AUDREY',
      'THORIN_GERALDINE',
      'THORIN_GEORGES_EDOUARD',
      'SKAKNY_FAYCAL'
    ]
  },
  LILLYBELLE: {
    id: 'LILLYBELLE',
    name: 'Lillybelle France',
    country: 'France',
    collaborators: [
      'ARIOUA_ZOUAOUI',
      'BOUDEN_LAURENT',
      'COSTA_HERVE',
      'DIAKHO_FODE',
      'EDJEKOUANE_KAMELIA',
      'GOUGES_FABIEN',
      'KASSOU_MAMODE_ALI_SHAN',
      'KHUN_ARTHUR',
      'MAJED_NAJMEDDINE',
      'MESMIN_CHRISTOPHE_DUGENIT',
      'NDINGA_BEATRICE',
      'RAHMANI_SONIA',
      'SAVATTE_ERWAN',
      'RAILLON_JAMES',
      'SIMONAZZI_GAEL',
      'TOUZELET_AMAURY'
    ]
  },
  LILLYBELLE_TOGO: {
    id: 'LILLYBELLE_TOGO',
    name: 'Lillybelle Togo',
    country: 'Togo',
    collaborators: [
      'AGBEMAVI_ELOM',
      'BAILLEUL_FRANK',
      'BOUAGADA_KHAREYDINE',
      'CALADO_GONCALO',
      'DJABAL_BRUNO',
      'EPEY_JOSE_KODJOVI',
      'ETTUH_PAULINE_AKOUA',
      'GANHOUEGNON_SAMUEL_ULRICH',
      'GAVON_ALEXANDRE',
      'HOUNZA_GISELE_ROSE',
      'KASSEKA_FORTUNEY_BOTIEKOU_BANDOU',
      'KOMBATE_MICHEL_ANGE_YEMPABE',
      'KONDO_KERIM',
      'LAWSON_DRONPENOU_JACQUES_TEVI_ESSENAM',
      'NOUMADO_GASTON_EDEH',
      'SOGAN_FIOVILADJA_ESENAM',
      'WAGA_DODJI'
    ]
  },
  LILLYBELLE_SENEGAL: {
    id: 'LILLYBELLE_SENEGAL',
    name: 'Lillybelle Sénégal',
    country: 'Sénégal',
    collaborators: [
      'COULIBALY_DOUGOUTIGUI'
    ]
  },
  LILLYBELLE_BURKINA: {
    id: 'LILLYBELLE_BURKINA',
    name: 'Lillybelle Burkina',
    country: 'Burkina Faso',
    collaborators: [
      'KABORE_RAISSA',
      'KABORE_ABDEL_AZIZ',
      'KERE_SERGE_THEOPHILE',
      'PALE_THOMAS_SIE',
      'BAKO_BOUREIMA'
    ]
  }
};

const COLLABORATORS = {
  // LILLYBELLE GROUP (Holding)
  BOISSEL_PASCALE: {
    id: 'BOISSEL_PASCALE',
    name: 'Boissel Pascale',
    structure: 'LILLYBELLE_H',
    team: 'Administration',
    phone: '06 70 81 57 73',
    email: 'p.boissel@lillybelle.eu',
    role: 'Directrice Administrative et Financière'
  },
  MAUDUIT_ARNAUD: {
    id: 'MAUDUIT_ARNAUD',
    name: 'Mauduit Arnaud',
    structure: 'LILLYBELLE_H',
    team: 'Commercial',
    phone: '06 10 69 10 23',
    email: 'a.mauduit@lillybelle.eu',
    role: 'Directeur Commercial Export Groupe'
  },
  MORNET_AUDREY: {
    id: 'MORNET_AUDREY',
    name: 'Mornet Audrey',
    structure: 'LILLYBELLE_H',
    team: 'Administration',
    phone: '06 08 74 88 00',
    email: 'a.mornet@lillybelle.eu',
    role: 'Contrôleur de gestion senior Groupe'
  },
  THORIN_GERALDINE: {
    id: 'THORIN_GERALDINE',
    name: 'Thorin Géraldine',
    structure: 'LILLYBELLE_H',
    team: 'Administration',
    phone: '06 84 36 39 27',
    email: 'geraldine.thorin@lillybelle.eu',
    role: 'Directrice RH et QSE Groupe'
  },
  THORIN_GEORGES_EDOUARD: {
    id: 'THORIN_GEORGES_EDOUARD',
    name: 'Thorin Georges-Edouard',
    structure: 'LILLYBELLE_H',
    team: 'Commercial',
    phone: '06 84 98 75 44',
    email: 'ge.thorin@lillybelle.eu',
    role: 'Président Directeur Général'
  },
  SKAKNY_FAYCAL: {
    id: 'SKAKNY_FAYCAL',
    name: 'Skakny Fayçal',
    structure: 'LILLYBELLE_H',
    team: 'Commercial',
    phone: '06 11 51 07 11',
    email: 'f.skakny@lillybelle.eu',
    role: 'Directeur Délégué'
  },

  // LILLYBELLE FRANCE
  ARIOUA_ZOUAOUI: {
    id: 'ARIOUA_ZOUAOUI',
    name: 'Arioua Zouaoui',
    structure: 'LILLYBELLE',
    team: 'Opérations',
    phone: '06 85 87 45 45',
    email: 'z.arioua@lillybelle.eu',
    role: 'Gestionnaire technique, avant-vente et R&D'
  },
  BOUDEN_LAURENT: {
    id: 'BOUDEN_LAURENT',
    name: 'Bouden Laurent',
    structure: 'LILLYBELLE',
    team: 'Opérations',
    phone: '06 61 82 83 29',
    email: 'l.bouden@lillybelle.eu',
    role: 'Directeur des Opérations'
  },
  COSTA_HERVE: {
    id: 'COSTA_HERVE',
    name: 'Costa Hervé',
    structure: 'LILLYBELLE',
    team: 'Commercial',
    phone: '06 07 80 09 74',
    email: 'h.costa@lillybelle.eu',
    role: 'Ingénieur Commercial'
  },
  DIAKHO_FODE: {
    id: 'DIAKHO_FODE',
    name: 'Diakho Fode',
    structure: 'LILLYBELLE',
    team: 'Opérations',
    phone: '06 72 13 92 03',
    email: 'f.diakho@lillybelle.eu',
    role: 'Gestionnaire Outils de mesures'
  },
  EDJEKOUANE_KAMELIA: {
    id: 'EDJEKOUANE_KAMELIA',
    name: 'Edjekouane Kamelia',
    structure: 'LILLYBELLE',
    team: 'Opérations',
    phone: '06 11 63 14 15',
    email: 'k.edjekouane@lillybelle.eu',
    role: 'Assistante IT et Cybersécurité'
  },
  GOUGES_FABIEN: {
    id: 'GOUGES_FABIEN',
    name: 'Gouges Fabien',
    structure: 'LILLYBELLE',
    team: 'Administration',
    phone: '06 88 38 21 38',
    email: 'fabien.gouges@lillybelle.eu',
    role: 'Assistant ADV et Finances'
  },
  KASSOU_MAMODE_ALI_SHAN: {
    id: 'KASSOU_MAMODE_ALI_SHAN',
    name: 'Ali-Shan Kassou Mamode',
    structure: 'LILLYBELLE',
    team: 'Opérations',
    phone: '07 86 18 58 18',
    email: 'a.kassou@lillybelle.eu',
    role: 'Stagiaire'
  },
  KHUN_ARTHUR: {
    id: 'KHUN_ARTHUR',
    name: 'Khun Arthur',
    structure: 'LILLYBELLE',
    team: 'Administration',
    phone: '07 84 08 40 37',
    email: 'a.khun@lillybelle.eu',
    role: 'Chargé de missions RH'
  },
  MAJED_NAJMEDDINE: {
    id: 'MAJED_NAJMEDDINE',
    name: 'Majed Najmeddine',
    structure: 'LILLYBELLE',
    team: 'Opérations',
    phone: '07 85 74 04 07',
    email: 'n.majed@lillybelle.eu',
    role: 'Chef de projets'
  },
  MESMIN_CHRISTOPHE_DUGENIT: {
    id: 'MESMIN_CHRISTOPHE_DUGENIT',
    name: 'Mesmin Christophe Dugenit',
    structure: 'LILLYBELLE',
    team: 'Supply Chain',
    phone: '07 89 61 38 25',
    email: 'c.mesmin@lillybelle.eu',
    role: 'Responsable Achats généraux, SST et Coordination'
  },
  NDINGA_BEATRICE: {
    id: 'NDINGA_BEATRICE',
    name: 'Ndinga Béatrice',
    structure: 'LILLYBELLE',
    team: 'Supply Chain',
    phone: '06 80 13 73 68',
    email: 'b.ndinga@lillybelle.eu',
    role: 'Gestionnaire Supply Chain'
  },
  RAHMANI_SONIA: {
    id: 'RAHMANI_SONIA',
    name: 'Rahmani Sonia',
    structure: 'LILLYBELLE',
    team: 'Opérations',
    phone: '06 87 53 98 87',
    email: 's.rahmani@lillybelle.eu',
    role: 'Responsable Support Telecom, IT et développement'
  },
  SAVATTE_ERWAN: {
    id: 'SAVATTE_ERWAN',
    name: 'Savatte Erwan',
    structure: 'LILLYBELLE',
    team: 'Commercial',
    phone: '07 86 37 99 49',
    email: 'e.savatte@lillybelle.eu',
    role: 'Technico-Commercial Compte Clés'
  },
  RAILLON_JAMES: {
    id: 'RAILLON_JAMES',
    name: 'Raillon James',
    structure: 'LILLYBELLE',
    team: 'Opérations',
    phone: '+34 682 43 35 84',
    email: 'j.raillon@lillybelle.eu',
    role: 'Expert Outils et Développement'
  },
  SIMONAZZI_GAEL: {
    id: 'SIMONAZZI_GAEL',
    name: 'Simonazzi Gaël',
    structure: 'LILLYBELLE',
    team: 'Commercial',
    phone: '06 61 31 56 14',
    email: 'g.simonazzi@lillybelle.eu',
    role: 'Directeur Général / Managing Director'
  },
  TOUZELET_AMAURY: {
    id: 'TOUZELET_AMAURY',
    name: 'Touzelet Amaury',
    structure: 'LILLYBELLE',
    team: 'Commercial',
    phone: '07 89 58 44 12',
    email: 'a.touzelet@lillybelle.eu',
    role: 'Directeur Commercial / Head of Sales'
  },
  BADER_FETOURI: {
    id: 'BADER_FETOURI',
    name: 'Bader Fetouri',
    structure: 'LILLYBELLE',
  },
  CLEMENT_MEUSNIER: {
    id: 'CLEMENT_MEUSNIER',
    name: 'Clément Meusnier',
    structure: 'LILLYBELLE',
    phone: '',
    email: 'bader.fetouri@lillybelle.eu',
    role: 'Directeur Général Adjoint'
  },

  // LILLYBELLE TOGO
  AGBEMAVI_ELOM: {
    id: 'AGBEMAVI_ELOM',
    name: 'Agbemavi Elom',
    structure: 'LILLYBELLE_TOGO',
    team: 'Opérations',
    phone: '+228 93 78 43 95',
    email: 'e.agbemavi@lillybelle.eu',
    role: 'Technicien Drive Test et Support Senior'
  },
  BAILLEUL_FRANK: {
    id: 'BAILLEUL_FRANK',
    name: 'Bailleul Frank',
    structure: 'LILLYBELLE_TOGO',
    team: 'Commercial',
    phone: '+228 70 11 24 04',
    email: 'f.bailleul@lillybelle.eu',
    role: 'Directeur Général Adjoint'
  },
  BOUAGADA_KHAREYDINE: {
    id: 'BOUAGADA_KHAREYDINE',
    name: 'Bouagada Khareydine',
    structure: 'LILLYBELLE_TOGO',
    team: 'Opérations',
    phone: '+228 91 65 48 66',
    email: '',
    role: 'Ingénieur Telecom'
  },
  CALADO_GONCALO: {
    id: 'CALADO_GONCALO',
    name: 'Calado Goncalo',
    structure: 'LILLYBELLE_TOGO',
    team: 'Opérations',
    phone: '+228 90 14 22 12',
    email: 'g.calado@lillybelle.eu',
    role: 'Directeur des Opérations Fibres Optiques FTTX'
  },
  DJABAL_BRUNO: {
    id: 'DJABAL_BRUNO',
    name: 'Djabal Bruno',
    structure: 'LILLYBELLE_TOGO',
    team: 'Opérations',
    phone: '+228 93 05 93 29',
    email: '',
    role: 'Stagiaire'
  },
  EPEY_JOSE_KODJOVI: {
    id: 'EPEY_JOSE_KODJOVI',
    name: 'Epey José Kodjovi',
    structure: 'LILLYBELLE_TOGO',
    team: 'Opérations',
    phone: '+228 90 60 96 30',
    email: 'jose.k.epey@lillybelle.eu',
    role: 'Technicien Drive test et support Senior'
  },
  ETTUH_PAULINE_AKOUA: {
    id: 'ETTUH_PAULINE_AKOUA',
    name: 'Ettuh Pauline Akoua',
    structure: 'LILLYBELLE_TOGO',
    phone: '+228 96 62 29 24',
    email: '',
    role: 'Agent entretien'
  },
  GANHOUEGNON_SAMUEL_ULRICH: {
    id: 'GANHOUEGNON_SAMUEL_ULRICH',
    name: 'Ganhouegnon Samuel Ulrich',
    structure: 'LILLYBELLE_TOGO',
    team: 'Opérations',
    phone: '+228 90 14 42 22',
    email: 'u.ganhouegnon@lillybelle.eu',
    role: 'Gestionnaire support senior et Chef de projet'
  },
  GAVON_ALEXANDRE: {
    id: 'GAVON_ALEXANDRE',
    name: 'Gavon Alexandre',
    structure: 'LILLYBELLE_TOGO',
    phone: '+228 90 00 25 63',
    email: '',
    role: 'Chauffeur - coursier'
  },
  HOUNZA_GISELE_ROSE: {
    id: 'HOUNZA_GISELE_ROSE',
    name: 'Hounza Gisele Rose',
    structure: 'LILLYBELLE_TOGO',
    team: 'Opérations',
    phone: '+228 91 25 39 01',
    email: '',
    role: 'Stagiaire'
  },
  KASSEKA_FORTUNEY_BOTIEKOU_BANDOU: {
    id: 'KASSEKA_FORTUNEY_BOTIEKOU_BANDOU',
    name: 'Kasseka Fortuney Botiékou Bandou',
    structure: 'LILLYBELLE_TOGO',
    team: 'Opérations',
    phone: '+228 90 60 96 29',
    email: 'bba.kasseka@lillybelle.eu',
    role: 'Gestionnaire support senior'
  },
  KOMBATE_MICHEL_ANGE_YEMPABE: {
    id: 'KOMBATE_MICHEL_ANGE_YEMPABE',
    name: 'Kombate Michel-Ange Yempabe',
    structure: 'LILLYBELLE_TOGO',
    team: 'Opérations',
    phone: '+228 92 11 98 62',
    email: 'ma.kombate@lillybelle.eu',
    role: 'Technicien Junior Drive Test'
  },
  KONDO_KERIM: {
    id: 'KONDO_KERIM',
    name: 'Kondo Kerim',
    structure: 'LILLYBELLE_TOGO',
    team: 'Opérations',
    phone: '+228 93 05 93 80',
    email: '',
    role: 'Stagiaire'
  },
  LAWSON_DRONPENOU_JACQUES_TEVI_ESSENAM: {
    id: 'LAWSON_DRONPENOU_JACQUES_TEVI_ESSENAM',
    name: 'Lawson Dronpenou Jacques Tevi Essenam',
    structure: 'LILLYBELLE_TOGO',
    team: 'Commercial',
    phone: '+228 90 60 95 16',
    email: 'jacques.t.lawson@lillybelle.eu',
    role: 'Technico-Commercial'
  },
  NOUMADO_GASTON_EDEH: {
    id: 'NOUMADO_GASTON_EDEH',
    name: 'Noumado Gaston Edeh',
    structure: 'LILLYBELLE_TOGO',
    team: 'Opérations',
    phone: '+228 90 60 96 18',
    email: 'ega.noumado@lillybelle.eu',
    role: 'Chef projet drive test et Support technique'
  },
  SOGAN_FIOVILADJA_ESENAM: {
    id: 'SOGAN_FIOVILADJA_ESENAM',
    name: 'Sogan Fioviladja Esenam',
    structure: 'LILLYBELLE_TOGO',
    team: 'Administration',
    phone: '+228 90 60 96 52',
    email: 'esenam.sogan-fioviladja@lillybelle.eu',
    role: 'Responsable Administrative et Comptable'
  },
  WAGA_DODJI: {
    id: 'WAGA_DODJI',
    name: 'Waga Dodji',
    structure: 'LILLYBELLE_TOGO',
    team: 'Opérations',
    phone: '',
    email: '',
    role: ''
  },

  INES_FOFANA: {
    id: 'INES_FOFANA',
    name: 'Inès Fofana',
    structure: 'LILLYBELLE_TOGO',
    phone: '',
    email: '',
    role: ''
  },

  // LILLYBELLE SÉNÉGAL
  COULIBALY_DOUGOUTIGUI: {
    id: 'COULIBALY_DOUGOUTIGUI',
    name: 'Coulibaly Dougoutigui',
    structure: 'LILLYBELLE_SENEGAL',
    team: 'Commercial',
    phone: '06 19 44 07 16',
    email: 'd.coulibaly@lillybelle.eu',
    role: 'Directeur Pays'
  },

  // LILLYBELLE BURKINA
  KABORE_RAISSA: {
    id: 'KABORE_RAISSA',
    name: 'Kabore Raissa',
    structure: 'LILLYBELLE_BURKINA',
    team: 'Administration',
    phone: '+226 56 80 24 89',
    email: 'r.kabore@lillybelle.eu',
    role: 'Responsable administrative et comptable'
  },
  KABORE_ABDEL_AZIZ: {
    id: 'KABORE_ABDEL_AZIZ',
    name: 'Kabore Abdel-Aziz',
    structure: 'LILLYBELLE_BURKINA',
    team: 'Opérations',
    phone: '+226 56 96 11 18',
    email: 'a.kabore@lillybelle.eu',
    role: 'Dessinateur et Superviseur de travaux'
  },
  KERE_SERGE_THEOPHILE: {
    id: 'KERE_SERGE_THEOPHILE',
    name: 'Kere Serge Théophile',
    structure: 'LILLYBELLE_BURKINA',
    team: 'Opérations',
    phone: '+226 55 50 67 60',
    email: 'sergekere@lillybelle.eu',
    role: 'Directeur Pays adjoint'
  },
  PALE_THOMAS_SIE: {
    id: 'PALE_THOMAS_SIE',
    name: 'Pale Thomas Sié',
    structure: 'LILLYBELLE_BURKINA',
    team: 'Opérations',
    phone: '+226 57 97 58 66',
    email: 't.pale@lillybelle.eu',
    role: 'Superviseur Génie civil et magasin'
  },
  BAKO_BOUREIMA: {
    id: 'BAKO_BOUREIMA',
    name: 'Bako Boureima',
    structure: 'LILLYBELLE_BURKINA',
    team: 'Supply Chain',
    phone: '',
    email: '',
    role: 'Stagiaire'
  }
};


/**
 * Utilitaires
 */
const ConfigUtils = {
  /**
   * Normaliser un nom de collaborateur pour le matching avec CSV
   */
  normalizeCollaboratorName(name) {
    return name
      .normalize('NFD')
      .replace(/[̀-ͯ]/g, '') // Remove combining diacritics (é→e, ç→c, etc.)
      .toUpperCase()
      .trim()
      .replace(/[-\s]+/g, '_') // Hyphens and spaces → underscores
      .replace(/[^A-Z0-9_]/g, ''); // Remove everything else
  },

  /**
   * Trouver un collaborateur par nom (avec fuzzy matching)
   */
  findCollaboratorByName(csvName) {
    const normalized = this.normalizeCollaboratorName(csvName);

    // Recherche exacte STRICTE
    for (const [id, collab] of Object.entries(COLLABORATORS)) {
      if (id === normalized) return collab;
    }

    // Fuzzy matching plus strict
    const csvParts = normalized.split('_').filter(p => p.length > 2);
    for (const [id, collab] of Object.entries(COLLABORATORS)) {
      const collabParts = id.split('_').filter(p => p.length > 2);
      const matches = csvParts.filter(part => collabParts.includes(part)).length;
      if (csvParts.length >= 3 && matches >= 3) return collab;
      if (csvParts.length === 2 && matches === 2) return collab;
    }

    return null;
  },

  /**
   * Ajouter un nouveau collaborateur
   */
  addCollaborator(collaborator) {
    if (!collaborator.id || !collaborator.name || !collaborator.structure) {
      throw new Error('id, name et structure sont requis');
    }

    COLLABORATORS[collaborator.id] = collaborator;
    if (STRUCTURES[collaborator.structure]) {
      STRUCTURES[collaborator.structure].collaborators.push(collaborator.id);
    }

    return collaborator;
  }
};

export { STRUCTURES, COLLABORATORS, ConfigUtils };
